// extracted by mini-css-extract-plugin
module.exports = {"container":"_3quwYdh8","title":"_3H0h4yds","flexContainer":"_18euVUDG","subheader":"_2aiYcuq2","imageContainer":"_3Te7IYg7","detailContainer":"_2c289rSq","dataContainer":"sNAyu9Sp","avatarWrapper":"_3nNk5ry1"};
    if(module.hot) {
      // 1754515030060
      var cssReload = require("!../../../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  